let ja = {
  "common": {
    //共通翻訳
    "returnButton": "戻る",
    "okButton": "OK",
  },
  //ホーム
  "home": {
    "myLesson": "マイコース",
    "learningAnalysis": "学習状況",
    "courseConditions": "受講状況",
    "learningProcess": "学習進捗",
    "performanceAnalysis": "成績状況",
    "liveMessage": "ライブ講義",
    "notLogin": "ログイン",
    "faceIn": "顔認識ログイン",
    "accountIn": "アカウント",
    "accountOrEmail": "メールアドレス/ユーザID",
    "passwordDigits": "パスワード（８～１６桁）",
    "rememberMe": "ログインしたままにする",
    "forgetPass": "パスワードを忘れた方はこちら",
    "identifyStart": "認証開始",
    "immediateLogin": "ログイン",
    "courseName": "コース名称",
    "teachingTime": "講義日付",
    "status": "ステータス",
    "clickJump": "参加",
    "userProtocol": "《プライバシー ポリシー》",
    "operation": "操作マニュアル",
    "faq": "よくあるご質問",
    "service": "サービス利用規約",
    "policy": "プライバシーポリシー",
    "keepLogin": "ログイン状態を保持する",
    "support": "サポート",
    "schcourseConditions": "受講状況(スケジュール)", 		 
	  "schperformanceAnalysis": "成績状況(スケジュール)",
    "welcome": "Study-artsへようこそ！",
    "selectCompanyTitle": "ログインしたい企業を選択してください。",
  },
  //错误显示画面
  "err": {
    "err1": "画面遷移中にエラーが発生しました。",
    "err2": "一度ログアウトをし、ブラウザを閉じて、しばらく経ってから再度お試しください。",
    "err3": "また、エラーが解消されない場合はStudyArtsサポートセンターまでお問い合わせください。",
    "err4": "データアクセス中に問題が発生しました。詳細については、StudyArtsチームにお問い合わせください",
    "revertErr": "ホームページへ戻る",
  },
  //学習詳細状況
  "aicourse": {
    "beginLearn": "開始",
    "endLearn": "終了",
    "timeLength": "期間",
    "week": "週",
    "weekPlan": "週",
    "hoursPre": "時間予定",
    "beforeKnowledge": "必須知識",
    "distinguish": "区分",
    "courseLanguage": "言語",
    "classification": "分類",
    "category": "コースカテゴリ"
  },
  //
  "courseScoreStatistics": {
    "beginLearningTime": "学習開始時間",
    "validityPeriod": "コース有効時間",
  },
  //community
  "community": {
    "content": "情報なし",
    "dataNone": "不正解問題はまだありません。",
    "down": "ダウンロード",
  },
  //成績分析
  "scoreStatistics": {
    "performanceAnalysis": "修了試験成績状況",
    "schPerformanceAnalysis":"修了試験成績状況(スケジュール)",
    "courseName": "コース名称",
    "courseNameInput": "コース名称を入力してください。",
    "validityPeriod": "コース有効期間",
    "chooseDate": "日付を選択",
    "search": "検索",
    "studentsCounst": "受講者数",
    "myScore": "得点",
    "aveScore": "平均点",
    "maxPoint": "最高点",
    "minPoint": "最低点",
    "point90": "合格",
    "point80": "不合格",
    "personCount": "人数",
    "proportion": "率",
    "passPercent": "合格基準点",
    "judge": "評価",
    "message1": "最高成績：",
    "message2": "点",
    "message3": "※プラットフォームコースは成績分析対象外です",
    "result": "結果",
    "testName": "試験名称",
    "finalExam": "修了試験",
  },
  "curriculum": {
    "exam": "修了試験",
    "errorCollection": "不正解問題集",
    "questionnaire": "アンケート調査",
    "scoreStatistics": "成績",
    "gotoLive": "ライブ講義",
    "question": "アンケート",
    "covenant": "誓約書",
    "thi__giua__ki": "中間試験"
  },
  "curriculumExam": {
      "listExam": "テスト一覧",
      "passExam": "合格率",
      "failExam": "不合格率",
      "doNotExam": "未完了",
      "rank": "ランキング表",
      "doingExam": "試験中に成績が確認できません。"
   },
  //試験はじめページ
  "examBegins": {
    "center": "試験センター",
    "notice": "試験における注意事項",
    "introduce": "試験説明",
    "first": "この試験は、参画したコースで学んだ内容（知識）の理解度を確認するための試験です。",
    "second": "試験の解答形式 は、多肢選択形式 （択一形式、複数選択）、穴埋め式、論述式などです。",
    "third": "この試験は、各章節の小テストが全てクリアされた後に行なう最終テストという位置づけ、試験を受ける前に、全ての小テストをクリアして下さい。",
    "rule": "試験規則",
    "one": "制限時間内に全問題を解答して下さい。 制限時間になったら自動的に試験が終了されます。",
    "two": "未回答の問題は、不正解と判断します。 ",
    "three": "全問題の解答後に、解答に間違いがないかを確認した上で、「提出」ボタンをクリックして試験を終了して下さい。",
    "remain": "受験回数",
    "current": "直近得点",
    "highest": "最高得点",
    "begin": "試験開始",
    "giveUp": "キャンセル",
    "notice_exam": "試験における注意事項",
    "notice_midterm": "試験における注意事項",
    "type": "表示形式",
    "notFull": "一問ずつ",
    "full": "すべて",
    "changeTypeShow": "表示モード変更"
  },
  "examResume": {
    "resume": "受験履歴",
    "point": "得点",
    "time": "試験時間",
    "jump": "授業ページへ",
  },
  "detailExam": {
    "finalExam": "修了試験",
    "seconds": " びょう",
    "minutes": " 分",
    "fullMark": "満点",
    "standardMark": "合格基準点",
    "yourMark": "得点",
    "pass": "合格",
    "fail": "不合格",
    "viewDetailWrong": "不正解問題の詳細",
    "viewChapter": "章節別の得点",
    "totalRightAnswer": "正解の問題数",
    "totalScore": "得点"
  },
  //不正解問題集
  "errorBook": {
    "errorBook": "不正解問題集",
    "prve": "前ページ",
    "next": "次ページ",
    "answerInput": "回答を入力してください......",
    "answer": "回答",
    "rightAnswer": "正解",
    "answerAnalysis": "解説",
    "download": "不正解リスト出力",
    "remove": "不正解リストから削除",
    "confirmMessage": "不正解リストから削除します。よろしいですか？",
  },
  "previewBook":{
    "previewBook": "修了試験プレビュー",
  },
  "active": {
    "goHome": "トップページへ戻る",
  },
  //
  "email": {
    "title": "パスワードのリセット",
    "email": "ご登録されているメールアドレスを入力してください。リセットのためのメールを送信します。",
    "emailWarning": "※ユーザIDにて本システムを利用する御客様の場合、本機能ご利用できません。パスワードをリセットしたい場合はユーザIDの発行先管理者にご連絡下さい。",
    "placeholder": "メールアドレスを入力してください。",
    "confirmplaceholder": "メールアドレス(確認)を入力してください。",
    "confirm": "送信",
    "message": "入力されたメールアドレスが一致していないです。",
  },
  "register_email": {
    "title": "パスワードリセットメール送信完了",
    "message": "ご登録されているメールアドレスへ、メールを送りいたしました。メールに記載されているURLからアクセスし、パスワードを変更してください。",
    "passwordResetSuccess": "パスワードをリセットしました。再度ログインしてください。",
    "timeout": "パスワードリセットURLの有効期限が切れました。お手数となりますが、ログイン画面の「パスワードを忘れた方はこちら」よりパスワードリセットメールの再送信を行ってください。",
    "checkMessage": "パスワードが一致していないです。",
  },
  "courseList": {
    "courseName": "コース名称",
    "courseNameInput": "コース名称を入力してください。",
    "validityPeriod": "コース有効期間",
    "chooseDate": "日付選択",
    "to": "～",
    "no": "No.",
    "operation": "操作",
  },
  "courseProgress": {
    "learningProcess": "学習進捗率",
    "search": "検索",
    "learnBeginDate": "受講開始日",
    "complete": "チャプター数",
    "uncomplete": "未完了チャプター数",
    "examhistory": "受験履歴",
    "isquestion": "アンケート",
    "look": "表示",
  },
  "personSet": {
    "changePass": "パスワード変更",
    "personInfo": "個人設定",
    "messageCenter": "情報センター",
    "changeFace": "プロフィール写真修正",
    "chooseImg": "画像選択",
    "save": "保存",
    "off": "キャンセル",
    "confirm": "変更",
    "currentPass": "現在のパスワード",
    "newPass": "新しいパスワード",
    "repeatPass": "新しいパスワード(確認)",
    "notMessage": "メッセージなし",
    "noticeTime": "通知時間",
    "noticeTittle": "通知内容",
    "status": "ステータス",
    "unread": "未読",
    "read": "既読",
    "userName": "ユーザ名",
    "email": "メールアドレス",
    "mobile": "携帯電話",
    "change": "OK",
    "passwordNotNull": "新しいパスワードは必須入力です。",
    "oldPasswordIncorrect": "現在のパスワードが正しくありません。",
    "passwordChangeFail": "パスワードの変更はできませんでした。",
    "imgSuccess": "プロフィール写真を修正しました。",
    "placeholder": "８～１６桁、大文字小文字、数字を含めて入力してください。",
    "defaultLanguage": "デフォルトシステム言語",
    "imageError": "サポート拡張子（gif,jpeg,jpg,png,bmp）を選択してください。",
    "birthday":"生年月日",
    "occupation":"職業",
    "synopsisUser": "自己紹介",
    "synopsisNonUser": "まだ自己紹介をしていません。",
    "enterName": "名前を入力してください。",
    "editInfoUser": "個人情報の編集",
    "enterSex": "性別選択。",
    "enterMobile": "連絡情報を入力してください。",
    "enterJob": "職業を入力してください。",
    "enterSynopsis": "紹介情報を入力してください。",
    "personInfoSanritsu": "お申込情報"
  },
  "contactUs": {
    "contactUs": "お問い合わせ",
    "email": "メールアドレス",
    "send": "送信",
    "problem": "質問内容を入力してください。",
    "sucess": "送信しました。",
    "sure": "確認番号",
    "sorry": "我々は、ご疑問を喜んで回答させていただき、当社の製品とサービスが何かご迷惑をかけている場合、我々は深くお詫び申し上げます。",
    "gohome": "トップページへ戻る",
    "faild": "送信できませんでした。",
    "sever": "ただいまサーバーが込み合っています。しばらくしてから再度試してください。",
    "resend": "再送",
  },
  //コース一覧ページ
  "schoolBusiness": {
    "sloganFour": "マイコース",
    "all": "全て",
    "introduceThree": "Don't miss out on business",
    "introduceFour": "Enroll in a course and build your best future, today.",
    "beginLearn": "トップへ",
    "elective": "選択コース",
    "generalCourse": "コース",
    "privateCourse": "コースセット",
  },
  "search": {
    "keyWord": "キーワードを入力してください。",
    "result": "検索結果なし",
  },
  "studySituationList": {
    "count": "受講コース進捗状況",
    "validityPeriodStart": "開始時間",
    "validityPeriodEnd": "終了時間",
    "distinguish": "コース区分",
    "studentEndDate": "受講完了日",
    "guarantee": "誓約書",
    "certificate": "証明書",
    "notRaised": "未提出",
    "raised": "提出",
  },
  "schStudySituationList": {
    "count":"受講コース進捗状況(スケジュール)",
    "validityPeriodStart": "開始予定日",
    "validityPeriodEnd": "完了予定日",
    "learnBeginDate": "受講開始日",
    "learnEndDate": "受講完了日",
    "learningProcess":"学習進捗率",
    "completionStatusFlag":"ローカル完成状態",
    "offlineCompleteTime":"完了日",
    "isDelay":"遅延状況",
    "finish": "完成",
    "undone": "未完成",   
    "delay": "遅延あり",
    "noDelay": "遅延なし",   
  },
  "task_answer": {
    "answerCommit": "採点",
    "examCommit": "提出",
    "answer": "回答",
  },
  "task_result": {
    "prev": "前へ",
    "next": "次へ",
    "wrong": "不正解",
    "reght": "正解",
    "answer": "正解",
    "analysis": "問題解析",
    "question": "問",
    "unShowAnswer": "本問題の解答を見ることができません。",
  },
  "rePassword": {
    "newPassword": "新パスワード（大文字や小文字、数字を混在する８～１６桁）",
    "repeact": "パスワード確認（大文字や小文字、数字を混在する８～１６桁のパスワードを設定してください。）",
    "confirm": "確定",
  },
  "read": {
    "catalogue": "目次",
    "note": "メモ",
    "chat": "コメント",
    "tips": "本コースに関するメモをここに書きましょう。",
    "login": "ログインしてください。",
    "save": "保存",
    "jump": "第",
    "page": "ページへ",
    "prev": "前へ",
    "next": "次へ",
    "returnCatalogue": "目次へ"
  },
  "week": {
    "status": "ステータス",
    "exercise": "小テスト",
    "score": "得点率",
    "undone": "未学習",
    "done": "学習済",
    "studing": "学習中"
  },
  "questionnaire": {
    "questionnaire": "アンケート調査票",
    "contentInput": "内容を入力してください。",
    "submit": "提出",
    "tempSave": "一時保存",
    "tempSaveHint1": "入力内容を一時的に保存しますか？",
    "tempSaveHint2": "注意：ブラウザやデバイスを切り替えたら、一時保存した内容は無くなります。",
    "noticeSuccess": "入力した内容を保存しました。",
  },
  "js": {
    "confirm": "OK",
    "quite": "ログアウトしますか？",
    "hint": "確認",
    "cancel": "キャンセル",
    "userNameNull": "ユーザ名は必須入力項目です。",
    "email": "メールアドレスを入力してください。",
    "formatWrong": "メールアドレスに不備があります。",
    "passwordNull": "パスワード情報を入力してください。",
    "passwordFormat": "英大文字や英小文字、数字を混在した８～１６桁のパスワードを入力してください。※「_+-=*#%$」以外の特殊文字は対象外。",
    "repeatPassword": "パスワード確認は必須入力項目です。",
    "different": "パスワードが一致していません。",
    "service": "誓約書を提出します。よろしいですか？",
    "account": "アカウント情報を入力してください。",
    "password": "パスワード情報を入力してください。",
    "beginLearning": "開始してもよろしいでしょうか。",
    "dataNone": "情報なし",
    "jumpToexam": "コンテンツの学習は全て完了してから「修了試験」を受けてください。",
    "examDataNone": "試験情報はありません。",
    "certificateDataNone": "修了証明書情報は登録されていません。",
    "jumpToQuestion": "「修了試験」を受けてから「アンケート」を回答してください。",
    "jumpToErrorBook": "コースを終了してから「不正解問題集」を利用してください。",
    "loginPlease": "ログインしてください。",
    "lastExam": "試験の採点中に再受験はできません。採点終了までしばらくお待ちください。",
    "no": "第",
    "placeholder": "ここに入力",
    "examOver": "試験の制限時間になり、強制終了します。制限時間までに解答した問題は自動的に提出されました。",
    "emailNone": "メールアドレスが存在しません。",
    "sendSuccess": "送信しました。",
    "returnHome": "トップページへ戻る",
    "problemInput": "質問を入力してください。",
    "submitConfirm": "小テストを提出します。よろしいですか？",
    "noLive": "ライブコースはまだありません。",
    "PleaseLogin": "ログインしてください。",
    "submitHint": "アンケートを提出します。よろしいですか？",
    "nonull": "アンケートに未記入項目が存在します。",
    "nocorrect": "試験の採点中に再受験はできません。採点終了までしばらくお待ちください。",
    "mostPage": "最大ページ数を超えました。",
    "leastPage": "最小ページ数を超えました。",
    "saveNotes": "確定：メモ保存",
    "unSaveNotes": "キャンセル：メモ保存しない",
    "dontSave": "メモを保存していません。",
    "wordMore": "入力できる最大文字数を超えました。",
    "saveSuccess": "保存しました。",
    "PleaseLogin": "本サービスはログインしてからご利用ください。",
    "nonull": "未回答の項目があります。全項目を回答してください。",
    "systemError": "システムエラーが発生しました。",
    "userNotExist": "該当のユーザは存在しません。",
    "passwordWrong": "パスワードは正しくありません。",
    "passErrorTimer": "パスワードが5回間違いました。アカウントを10分程度ロックされます。",
    "passLock": "アカウントを10分程度ロックされました。後で再確認してください。",
    "failMatch": "顔を検出できません。カメラの向きや設定を確認してください。",
    "faceFail": "顔認証に失敗しました。",
    "AccecpProtocol": "契約内容及びプライバシーポリシーを読んで、同意してください。",
    "submitConfirmTest": "修了試験を提出します。よろしいですか？",
    "submitConfirmExam": "中間試験を提出します。よろしいですか？",
    "submitSuccessExam": "中間試験を完了しました。 結果を確認するには、「成績」ボタンをクリックしてください。",
    "submitSuccessTest": "修了試験を提出しました。「成績」をクリックし、結果を確認してください。",
    "submitSuccessTask": "小テストは提出しました。結果は、「得点率」で確認してください。",
    "uncheckMessage": "チェックされていない誓約書があります。チェックしてから再度提出してください。",
    "networkErr":"ネットワーク通信エラーが発生しました。",
    "confirmSaveNotes": "メモ内容は更新されました。保存してよろしいでしょうか。",
    "confirmJoinCourseOnline": "本コースに参加しますか？",
    "alertCourseOnlineEnd": "本コースは終了しました！",
    "exerciseMsg": "小テストを提出します。よろしいでしょうか。",
    "commonCourseMessage":"本コースのグローバルコース「{1}」を受講しています。本コースを受講開始すると、既に受講したグローバルコース「{2}」の受講結果がクリアされます。よろしいですか？",
    "downloadPdfFalse": "請求書のダウンロードに失敗しました。請求書のエクスポートを行うには、コースに再登録が必要です。",
    "registerApplyCourseFalse": "コースのお申込処理中に予期しないエラーが発生しました。 大変申し訳ございませんが、ブラウザーを一度終了してから開き直して、あらためてお申込できるかお試しください。"
  },
  "new": {
    "title1": "おすすめコース",
    "title2": "設定",
    "title3": "もっと",
    "title4": "コース入れ替え",
    "title5": "検索結果",
    "title6": "全て",
    "title7": "終了",
    "title8": "ライブ中",
    "title9": "未開始",
    "title10": "すべて選択",
    "title11": "すべて選択を解除",
    "title12": "メモ出力",
    "title13": "回答状況確認画面",
    "title14": "総質問数",
    "title15": "回答質問数",
    "title16": "使用時間",
    "title17": "警告<br>初期設定のパスワードのままで利用されています！セキュリティ強化のため、必ずパスワードの変更を行ってください。",
    "title18": "入力した新しいパスワードは現在のパスワードと同じです。",
    "title19": "学習進捗",
    "title20": "学習開始",
    "title21": "コース修了",
    "title22": "学習完了",
    "showCompletedCourse": "修了コースも含む",
    "title24": "満点",
    "title25": "編集",
    "title26": "まだ試験を受けていないため、成績を参照することができません。",
    "title27": "試験の採点中に成績の確認はできません。採点終了までしばらくお待ちください。",
    "title28": "現在のパスワードは必須入力項目です。",
    "title30": "学習中にページを飛ばすことができません",
    "title31": "テストをやめる",
    "title32": "テストをやめます。よろしいですか？",
    "title33": "アンケート",
    "title34": "修了申請",
    "title35": "修了申請を提出します。よろしいですか？",
    "title36": "修了申請を提出しました。「修了申請」を再度クリックし、申請結果を確認してください。",
    "title37": "再受験します。よろしいですか？",
    "title38": "（※最終回の試験の得点で合格判定します）",
    "title39": "遷移",
    "title40": "受講開始前です。受講開始までしばらくお待ちください。",
    "title41": "該当コースの有効期限外であるため、アクセスできません。管理者へご連絡してください。",
    "title42": "未回答の問題がありますが、そのまま提出します。よろしいですか？",
    "title43": "パスワード変更しました。再度ログインしてください。",
    "title44": "有効期間",
    "title45": "なし",
    "title46": "アンケートの前に誓約書を提出してください。",
    "title47": "アンケートの前にコースを修了してください。",
    "title48": "「修了試験」を合格してから「誓約書」を提出してください。",
    "title49": "「修了試験」を合格してから「誓約書」を提出してください。",
    "title50": "進捗確認",
    "title51": "受講者氏名",
    "title52": "所属地区",
    "title53": "活用組織",
    "title53_1": "活用組織",
    "title54": "所属組織",
    "title54_1": "所属組織",
    "title55": "離任日",
    "title56": "コース区分",
    "title57": "学習進捗",
    "title58": "最新成績",
    "title59": "修了試験合格判定",
    "title60": "学習開始日",
    "title61": "学習修了日",
    "title62": "完了した章数",
    "title63": "未完成章数",
    "title64": "誓約書",
    "title65": "アンケート",
    "title66": "修了申請",
    "title67": "離任者含む",
    "title68": "受講者学習進捗状況",
    "title69": "受講者氏名を入力してください。",
    "title70": "EXCELファイルエクスポート",
    "title71": "活用組織を選択してください。",
    "title72": "所属組織を選択してください。",
    "title73": "コース区分を選択してください。",
    "title74": "0から",
    "title75": "100まで",
    "title76": "修了試験合格判定を選択してください。",
    "title77": "進捗範囲",
    "title78": "修了申請を選択してください。",
    "title79": "エクスポート",
    "title80": "所属地区を選択してください。",
    "title81": "コースはまだ公開されません。内容変更の可能性がありますので、「修了試験」は開始できません。公開されるまでもう少しお待ちください。",
    "title82": "コースはまだ公開されません。内容変更の可能性がありますので、「アンケート」は開始できません。公開されるまでもう少しお待ちください。",
    "title83": "コースはまだ公開されません。内容変更の可能性がありますので、「誓約書」は開始できません。公開されるまでもう少しお待ちください。",
    "title85": "クリア",
    "title86": "通知",
    "title87": "次のページに移動する前に、このビデオを終了する必要があります !",
    "title88": "この章節にはコンテンツが存在しません！",
    "title89": "このコンテンツは現在ご利用いただけません。しばらくしてからやり直しください。",
    "title90": "あなたは本コースの担当教師ではないためコースの詳細を見ることはできません。",
    "title91": "依存コース「{0}」 はまだ完了されていない為本コースにアクセスできません！",
    "title92": "依存コースを完了した後、「{1}」日後に本コースを開始して下さい。",
    "title93": "あなたの担当コースがないため、このページにアクセスできません。",
    "title94": "この受講者は本コースをまだ参加していない為、詳細を参照できません。",
    "title95": "本日",
    "title96": "中間試験がまだ登録されていないため、中間試験を受けることができません。",
    "title97": "修了試験は実施中のため、中間試験を受けることができません。",
    "title98": "中間試験は実施中のため、修了試験を受けることができません。",
    "title99": "修了試験は実施中です。続けてよろしいでしょうか。",
    "title100": "中間試験は実施中です。続けてよろしいでしょうか。",
    "title101": "実施中の別中間試験が存在します。当中間試験を開始するためにその中間試験を完了しないといけません。",
    "title102": "当中間試験にまだ問題が登録されていない為、実施できません。",
    "title103": "不正解数",
    "title104": "コンテンツはまだ完了していない為、テストを実施できません。",
    "title105": "テスト合格率を満たさない為、修了試験を実施できません。",
    "title106": "あなたは本コースの受講者ではない為、本コースを開始できません。",
    "title107": "あなたは本コースの受講者ではない為、本コースを終了できません。",
    "title108": "当コースにまだコンテンツが登録されていないため、コースの詳細を参照することができません。",
    "title109": "このアカウントは無効になっています！",
    "title110": "あなたは本コースの受講者ではない為、コースを修了することができません。",
    "title111": "学習進捗_",
    "title112": "この受講者は試験を実施したことがない為、試験成績のファイルをエクスポートできません。",
    "title113": "このコースでは受験した学生がいないため、試験成績のファイルをエクスポートできません。",
    "title114": "この受講者はライブ講義の受講者として設定されていないため、出欠情報をエクスポートできません。",
    "title115": "問題集",
    "title116": "一覧",
    "title117": "人気コース",
    "title118": "人気コース",
    "title119": "最新",
    "title120": "おすすめコース",
    "title121": "￥",
    "title122": "あなたが試験でとれた点数は",
    "title123": "不正解問題の詳細",
    "title124": "確認",
    "title125": "試験は採点中です。試験が採点された後、[成績]ボタンを押下してを確認してください。",
    "title126": "再確認必要問題一覧",
    "title127": "再確認",
    "title128": "再確認必要問題一覧",
    "title129": "表示",
    "title130": "最新コース",
    "title131": "人気コース",
    "title132": "おすすめコース",
    "title133": "カテゴリー別コース",
    "title134": "配置",
    "title135": "人気",
    "title136": "高い評価",
    "title137": "高い順",
    "title138": "安い順",
    "title139": "最新",
    "title140": "コースの配置",
    "title141": "名",
    "title142": "カートに追加",
    "title143": "お申し込み",
    "title144": "価格",
    "title145": "学習予定時間",
    "title146": "時間",
    "title147": "セクション数",
    "title148": "割引有効期間",
    "title149": "受講者数",
    "title150": "コース詳細内容",
    "title151": "目次",
    "title152": "空カート",
    "title153": "コースの価格",
    "title154": "章節",
    "title155": "合計",
    "title156": "関連コース",
    "title157": "本コースは既にカートに追加されました。",
    "title158": "受講者のコメント",
    "title159": "受講者の評価",
    "title160": "本コースについての評価",
    "title161": "送信",
    "title162": "申込",
    "title163": "学習開始",
    "title164": "振込",
    "title165": "振込先の情報",
    "title166": "口座番号",
    "title167": "銀行名",
    "title168": "合計",
    "title169": "振込内容",
    "title170": "氏名",
    "title171": "メール/ユーザID",
    "title172": "電話番号",
    "title173": "注意：　振り込む際、Study-artsの振込内容に記載されている振込番号を正確にご記入ください。",
    "title174": "申し込んだコースの情報",
    "title175": "割引前の価格",
    "title176": "割引価格",
    "title177": "購入金額",
    "title178": "コースのお申込みを受け付けました！",
    "title179": "StudyArts コースの申し込みが完了いたしました。管理者による登録情報の確認が終了次第、速やかに登録詳細に関する案内をお送りさせていただきます。",
    "title180": "念のため、振込内容（振込番号）をメモしておいてください。",
    "title181": "ホームページに戻る",
    "title182": "お申し込み",
    "title183": "紹介コース一覧",
    "title184": "このライブ講義に参加した受講者がいないため、出席情報のファイルをエクスポートできません。",
    "title185": "データがない為、ファイルをエクスポートすることができません。",
    "title186": "HOTコース",
    "title187": "別のデバイスで試験を受けたため、最初からやり直しないといけません。",
    "title188": "このデバイス・ブラウザで試験を受けたい場合は最初から始める必要があります。",
    "title189": "全てのカテゴリー",
    "title190": "共通カテゴリー",
    "title191": "あなたの提出は成功しませんでした。ネットワーク接続をもう一度確認してください。または、直接お問い合わせください",
    "title192": "該当コースは既にスケジュールに存在しています。スケジュールコースを確認してください。",
    "title193": "不正解問題集",
    "title194": "この試験では、この受講者の不正解はありませんでした。",
    "title195": "当コースは既にカートに追加されました。",
    "title196": "購入を続ける",
    "title197": "当コースについての評価はまだありません。",
    "title198": "コメントを入力してください。",
    "title199": "氏名を入力してください。",
    "title200": "メールを入力してください。",
    "title201": "電話番号を入力してください。",
    "title202": "正しい電話番号を入力してください。",
    "title203": "隠れる",
    "title204": "振込番号",
    "title205": "振込金額",
    "title206": "申込情報出力",
    "title207": "お気に入り",
    "title208": "X",
    "title209": "不正解問題は全て削除されました！",
    "title210": "試験の実施中にブラウザやデバイスを切り替えた場合、答えた内容は保存されません。",
    "title211": "選択コース",
    "title212": "コース紹介",
    "title213": "担当先生紹介",
    "title214": "無料",
    "title215": "無料コース",
    "title216": "「修了試験」を完了した後、「請求書」を実行してお願いします。",
    "title217": "アンケートを提出する前にアンケート内容確認のチェックボックスをオンにしてください。",
    "title218": "この受講者の出席をとりますが、よろしいですか？",
    "title219": "注意",
    "title220": "注目のコース",
    "title221": "全てのカテゴリー",
	  "title222": "修了コース",
    "title223": "銀行口座",
    "title224": "選択したコース",
    "title225": "コース検索",
    "title226": "その他の銀行",
    "title227": "フィルター",
    "title228": "登録確認",
    "title229": "削除",
    "title230": "名前",
    "title231": "匿名",
    "title232": "コメントをここに入力してください。",
    "title233": "Study-Arts",
    "title234": "メール/ユーザID確認",
    "title235": "メールの入力内容とメール確認の入力内容が不一致です。",
    "title236": "登録承諾",
    "title237": "登録拒否",
    "title238": "承認",
    "title239": "拒否",
    "title240": "プレビュー",
    "title241": "正しい氏名を入力してください。",
    "title242": "正しいメールを入力してください。",
    "title243": "メールが既に存在します。別のメールにて申込するか、又はこのメールでログインしてからコースを申込んでください。",
    "title244": "既にこのコースを申込みました。",
    "title245": "メール確認を入力してください。",
    "title246": "メール",
    "title247": "メール確認。",
    "title248": "いいえ",
    "title249": "必須入力項目が未入力です（背景が薄ピンク色となる箇所）。記入の上再度提出してください。",
    "title250": "StudyArtsオンラインコースのお申込みありがとうございました。メール又は下記の請求書ダウンロードにて請求書の内容ご確認下さい。",
    "title251": "請求書のお支払い案内に従い、お早めにお支払いお願いします。お支払い完了後、ログイン情報をメールにて送付します。",
    "title252": "申請者氏名:",
    "title253": "メールアドレス:",
    "title254": "申込地域",
    "title255": "地域番号：",
    "title256": "地域名称：",
    "title257": "請求書ダウンロード",
    "title258": "地域番号",
    "title259": "様",
    "title260": "発行日",
    "title261": "年",
    "title262": "月",
    "title263": "日",
    "title264": "学費請求書",
    "title265": "ご請求金額",
    "title266": "項目",
    "title267": "金額",
    "title268": "コース期間",
    "title269": "①　次のいずれかの支払い方法を選択してください",
    "title270": "WeChat 支払い: WeChat で次の QR コードをスキャンし、この支払い通知をアップロードし、",
    "title285": "送金 者に関する情報を入力してください。リアルタイム為替レート、手数料 1.3%。",
    "title271": "②　海外送金：銀行経由で下記の学校口座に送金してください。",
    "title272": "円",
    "title273": "申込地域：",
    "title274": "申込情報確認",
    "title275": "下記のお申込情報を確認してください。",
    "title276": "下記のお申込情報をご確認頂き、申込地域を選択した上でお申込してください。",
    "title277": "申込番号",
    "title278": "内訳",
    "title279": "※海外送金に必要な振込手数料は送金者のご負担となります。",
    "title280": "修正不可",
    "title281": "※請求書についてご質問があれば、電話にて下記までお問合せ下さい。",
    "title282": "お問い合わせ番号：",
    "title283": "コース名称：",
    "title284": "今回のお申し込みコースには、すでにお申し込み済みのコースがあるため、お申込み対象コースは適切かどうか再確認ください。",
    "title290": "そのままお申込みしたい場合は、「お申し込み」ボタンを押下してください。",
    "title289": "ただし、過去のお申込み情報が上書きされますので、ご注意ください。",
    "title286": "お申込み",
    "title287": "キャンセル",
    "title288": "オンライン授業請求書_",
    "title291": "無料",
    "title292": "申込",
    "title293": "情報確認",
    "title294": "進捗状況をエクスポート"
  },
  "manage": {
    "look": "表示",
    "discription": "概要",
    "students": "受講者一覧",
    "lessons": "コース一覧",
    "detail": "詳細",
    "student": "受講者管理",
    "lesson": "コース管理",
    "questions": "問題一覧",
    "sex": "性別",
    "lesson_begin": "未開始コース",
    "lesson_learning": "学習中コース",
    "lesson_end": "修了コース",
    "default": "全コース",
    "manage_info": "情報管理",
    "download": "ダウンロード",
    "coursesOnline": "受講者数",
    "downloadStudents": "受講者一覧出力",
    "attendance": "出席情報",
    "presentList": "出席の受講者一覧",
    "absentList": "欠席の受講者一覧",
    "statusAttendance": "出欠ステータス",
    "present": "出席",
    "absent": "欠席"
  },
  "manage_questions": {
    "questions_id": "問題のID",
    "questions_content_title": "問題内容",
    "questions_audio": "音声",
    "questions_video": "動画",
    "questions_image": "画像",
    "questions_created": "自作リスト",
    "chosse_questions": "問題形式を選択してください。",
    "chosse_questions_one": "単一選択問題",
    "chosse_questions_more": "複数選択問題",
    "questions_writing": "記述式問題",
    "chosse_answer_more": "複数問題",
    "chosse_status_questions": "問題分類を選択してください",
    "questions_exercise": "試験",
    "questions_test": "小テスト",
    "chosse_teacher_create": "問題作成した先生を選択して下さい。",
    "chosse_chapter": "章を選択してください。",
  },
  "live_lesson": {
    "hiden": "検索入力エリアの非表示",
    "display": "検索入力エリアの表示",
  },
  "profile": {
    "name": "名前",
    "sex": "性別",
    "email": "メール",
    "statistic": "集計",
    "sum_lesson": "コース総数",
    "lesson_begin": "未開始コース数",
    "lesson_learning": "学習中コース数",
    "lesson_end": "修了コース数",
    "detail_lesson": "コースの詳細",
    "course": "コース",
    "discription": "備考",
    "link": "URLリンク",
    "studyTime": "参加時間",
    "showStatical": "集計情報表示",
    "jonhLiveCourse": "ライブ講義の出席回数",
    "noJonhLiveCourse": "ライブ講義の欠席回数",
  },
  "manage_lesson": {
    "keyWord": "コースタイトルを入力してください。",
    "lesson": "コンテンツ",
    "lesson_list": "コース目次 ",
    "total_lesson": "章総数",
    "total_excercise": "小テスト総数",
    "total_student": "受講者数",
    "statistical": "集計",
    "time_course": "コース期間",
    "teacher_charge": "担当教員",
    "status_course": "コースステータス",
    "live_lesson": "学習中",
    "not_stater": "未開始",
    "not_open": "未開始",
    "next_page_details": "コース紹介",
    "info_course": "コース情報",
    "status1": "未学習受講者",
    "status2": "学習中受講者",
    "status3": "学習済受講者",
    "clear": "クリア",
    "choose_date": "問題作成日をご選択ください",
    "static": "試験成績",
  },
  "manage_student": {
    "lesson_normal": "学習コース",
    "lesson_test": "テストコース",
    "type": "分類",
    "time": "期間",
    "count_of_students": "受講者数",
    "teacher": "担当教員",
    "job": "役割",
    "mobile": "連絡先",
    "to_chuc": "活用組織",
    "level": "等級",
    "age": "生年月日",
    "area": "国家（言語）",
    "chi_nhanh": "所属組織",
    "male": "男",
    "female": "女",
    "charge": "担当対象コース",
    "not_charge": "担当対象外コース",
    "status": "ステータス",
    "person_charge": "担当者",
    "me": "自分",
    "not_me": "他人",
    "lesson_unlocked": "未学習",
    "lesson_locked_not_study_end": "学習中",
    "lesson_study_end_not_exam": "コンテンツ学習完了",
    "lesson_exam_doing": "最終テスト実施中",
    "lesson_exam_end": "最終テスト採点中",
    "lesson_unpass": "未合格",
    "lesson_pass": "合格",
    "lesson_tuyet_doi": "満点",
    "lesson_end": "終了",
    "app_sp": "アプリケーションとサポート",
    "keyWord": "コース名を入力してください。",
    "exam_not_me": "ユーザは該当コースの受講者ではない",
    "live_time": "ライブ時間",
    "hour": "時間",
    "minute": "分",
    "export": "成績出力",
    "exportDiligent": "出欠情報のエクスポート",
    "noJonhLive": "不参加",
  },
  "statictical" : {
    "chapter_status": "章節のステータス",
    "total_chapter": "章総数",
    "excercise_status": "小テストのステータス",
    "total_excersice": "小テスト総数",
    "completed": "学習済",
    "unstudied": "未学習",
    "studying": "学習中",
    "scored": "採点済",
    "unscored": "未採点",
    "waiting_scoring": "採点待ち",
  },
  "mid_term": {
    "mid_term": "中間試験",
    "choose_mid_term": "中間試験をご選択ください",
  },
  "wrong_book": {
    "examList": "試験一覧"
  },
  "preview": {
    "examList": "プレビュー対応試験一覧"
  },
  "comments": {
    "commentName": "コメント一覧",
    "titleStatus": "未参加コースの中にあるコメントを含む",
    "content": "関連コンテンツ",
    "countConv": "コメント件数",
    "timeSeen": "最後に見た時間",
    "detail": "詳細"
  },
  "courseOnline": {
    "timeCourse": "講義期間",
    "comingSoon": "まもなく開始します",
    "title1": "参加したいコースは[XXXXX]です。",
    "title2": "本コースの開始までは後XX分です。",
    "title4": "本コースに参加したいですか。",
    "attendance": "当講義は終了したため、参加できません。代わりに一時的に他の講義に受講した場合、[XXX]を押下するこてで当講義の出席がとられることになります。",
    "comfirmRejoin": "よろしいですか。",
    "join": "出席とる",
    "reBegin": "再参加",
    "joinSuccess": "本コースに出席を取られることが完了しました。",
    "joinError": "本コースに出席を取られることが失敗しました。",
    "btitle1": "[XXX]を押下すると講義に参加することができます。",
    "btitle2": "オンライン講義用のアプリが開かれないなら、[XXX]を押下してください。",
    "btitle3": "注意：この方法でアクセスすると本コースでは出席を取られない為、講義が終了後自分で出席を取ってください。",
    "draft": "予備",
    "courseName": "講義名称",
    "courseNameInput": "講義名称を入力してください。",
    "quantityAlert": "このライブ講義は、最大人数に達しています。これ以上の参加者は、参加できません。"
  },
  "notification": {
    "title1": "これはあなたが開始していないコースの通知です。",
    "title2": "通知を閲覧する為にコースを開始する必要がありますが、開始しますか？",
    "common": "以下の新しい通知が届きました。",
  },
  "scoreStaticNew": {
    "noInformation": "該当受講者の受験情報なし",
    "timeExamStart": "試験開始時間",
    "timeExamEnd": "試験終了時間",
    "timeExamConducted": "試験実施時間",
    "examDate": "試験開始日",
    "timeExamConductedNew": "試験実施時間",
  },
  "manual": {
    "changeLanguage": "言語変更",
    "searchCourse": "コース検索",
    "personalInfo": "個人情報",
    "forgotPass": "パスワード忘れた場合",
    "changeAva": "プロフィル写真の変更",
    "changeInfo": "個人情報の変更",
    "changePass": "パスワード変更",
    "commentNoti": "新コメント通知",
    "participation": "コース参加", 
    "exercise": "小テスト",
    "markExercise": "小テスト率",
    "midTerm": "中間試験",
    "finalExam": "修了試験",
    "achievements": "成績確認",
    "wrongList": "不正解問題集",
    "general": "共通",
    "endCourse": "コース終了",
    "achievementStudent": "受講者の成績",
    "settingProcedure": "設定の手順書",
    "pwa": "スマホ用のマニュアル",
    "infoAcc": "アカウント情報",
    "jonhExam": "受験",
  },
  "scoreNew": {
    "title1": "章節別の得点",
    "title2": "正解率",
    "title3": "得点率",
    "title4": "章名",
    "title5": "問題の総数",
    "title6": "正解の問題数",
    "title7": "不正解の問題数",
    "title8": "得点",
    "title9": "試験成績の出力",
    "title10": "成績詳細",
  },
  "manualNew": {
    "type_1": "はじめて利用する方へ",
    "type_1_1": "パソコンの場合",
    "type_1_2": "スマホ・タブレットの場合",
    "type_2": "ログイン・ログアウト",
    "type_2_1": "言語選択",
    "type_2_2": "ログイン",
    "type_2_3": "パスワード忘れた場合",
    "type_2_4": "ログアウト",
    "type_3": "コース受講",
    "type_3_1": "コース検索",
    "type_3_2": "マイコース",
    "type_3_3": "コンテンツ閲覧",
    "type_3_4": "中間試験",
    "type_3_5": "修了試験",
    "type_3_6": "成績参照",
    "type_3_7": "誓約書",
    "type_3_8": "アンケート",
    "type_3_9": "メモ出力",
    "type_3_10": "修了申請",
    "type_4": "学習状況",
    "type_4_1": "受講状況",
    "type_4_2": "成績状況",
    "type_5": "ライブ講義",
    "type_5_1": "講義検索",
    "type_5_2": "講義参加",
    "type_6": "プロファイル",
    "type_6_1": "プロファイル写真変更",
    "type_6_2": "情報変更",
    "type_6_3": "システム言語変更",
    "type_6_4": "パスワード変更",
    "type_7": "管理機能",
    "type_7_1": "管理対象者進捗状況参照",
    "type_7_2": "受講者管理",
    "type_7_3": "コース管理",
    "type_7_4": "出席情報",
    "type_7_5": "ライブ講義",
    "type_3_3_1": "♦ コースを開始する",
    "type_3_3_2": "♦ コースを選択する",
    "type_3_3_3": "♦ コンテンツを上下に移動する",
    "type_3_3_4": "♦ ズームイン/ズームアウト",
    "type_3_3_5": "♦ メモ",
    "type_3_3_6": "♦ コメント",
    "type_3_3_7": "♦ ページの遷移",
    "type_3_3_8": "♦ 小テスト",
    "type_3_3_9": "♦ 小テストの得点を表示する",
    "type_3_3_10": "♦ 戻る",
  },
  "codeStatus": {
    "code_1_99": "データなし",
    "code_1_0": "正常",
    "code_1_1": "未開始",
    "code_1_2": "有効期間外",
    "code_1_3": "依存コース「{0}」は終了していないため、本コースを開始できません。",
    "code_1_4": "依存コースは学習完了したが、依存日数はまだ満たさない"
  },
  "online_ja": {
    "attendance1": "当ライブ講義は既に終了したため、ご参加できません。",
    "attendance2": "手動で出席を取りたい場合は、「XXX」ボタンにてお取りください。",
    "attendance3": "Web会議室を再利用したい場合は、「XXX」ボタンにてこのWeb会議室に入室してください。",
    "join": "出席取る",
    "cancel": "キャンセル",
    "rejoin": "再参加",
    "title": "確認",
    "title1": "「XXX」を押下することでライブ講義に参加してください。",
    "title2": "注意：ライブ講義のアプリケーションを開かなくて参加できない場合に、「XXX」ボタンを押下することでStudyArts経由せず、直接に参加して下さい。但し、直接参加する場合は自動的に出欠を取れないため、ライブ講義の終了後に再度出席を取って下さい。",
    "draft": "直参加",
    "clickJump": "参加",
  }
}
export default ja;



// WEBPACK FOOTER //
// ./src/assets/languages/ja.js